export const Arrow = () => {
  return (
    <svg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.24074 6.1142L0 0H12L6.75926 6.1142C6.36016 6.57981 5.63984 6.57981 5.24074 6.1142Z'
        fill='var(--bg-color)'
      />
    </svg>
  );
};
